import { render, staticRenderFns } from "./Fundamental_mobile.vue?vue&type=template&id=51ccff9d&scoped=true&"
import script from "./Fundamental_mobile.vue?vue&type=script&lang=js&"
export * from "./Fundamental_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Fundamental_mobile.vue?vue&type=style&index=0&id=51ccff9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ccff9d",
  null
  
)

export default component.exports